
import { Component, Prop, Vue } from 'vue-property-decorator';
import List from '../components/ListPc.vue';
import { DownloadUrls, So360DownloadCallbackData } from '../config/types';

@Component({
  components: { List },
})
export default class PcGameListSection extends Vue {
  @Prop({ required: true }) downloadUrls!: DownloadUrls;
  @Prop({ default: '' }) baiduApiToken!: string;
  @Prop() so360DownloadConfig?: So360DownloadCallbackData;
}
